import { Autocomplete, Chip, CircularProgress, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import { IStandardMultipleAutocomplete } from '../../_common/interface/autocomplete/iMultipleAutocomplete';
import { IDropdownData } from '../../_common/interface/dropdown/iDropdownData.interface';

interface IMultipleExtAutocomplete extends IStandardMultipleAutocomplete {
    itemsLoader: (parentId?: number) => Promise<any>,
    label: string
}


export const MultipleAutoComplete = (params: IMultipleExtAutocomplete) => {

    const [isLoading, setLoading] = useState(false);
    const [items, setItems] = useState<Array<IDropdownData>>([]);
    const [loadedParentId, setLoadedParentId] = useState<number | undefined>();

    useEffect(() => {
        if (params.loadOnOpen) {
            if (params.hasParent) {
                if (params.parentId && params.parentId > 0) {
                    if (loadedParentId !== params.parentId) {
                        setItems([]);
                        setLoadedParentId(undefined);
                    }
                } else if (items.length > 0) {
                    setItems([]);
                    setLoadedParentId(undefined);
                }
            }

            return;
        }

        if (params.hasParent === true) {
            if (params.parentId ? params.parentId > 0 : null) {
                fetchItems(params.parentId);
            }
            else if (items?.length > 0) {
                setItems([]);
            }
        }
        else {
            fetchItems();
        }
    }, [params.parentId, params.loadOnOpen]);

    useEffect(() => {
        if (items && params.items && items.length && params.items.length && params.items[0].name === undefined) {
            var _items = items.filter((m: any) => {
                if (params.items && params.items.length) {
                    var itemIds = params.items.map((i: any) => i.id);
                    return itemIds.includes(m.id);
                }
            });
            params.onChange?.({ target: { name: params.name, value: _items } }, _items, params.name);
        }
    }, [params.items, items]);

    function fetchItems(parentId?: number) {
        setLoading(true);
        return params.itemsLoader(parentId)
            .then(
                (json) => {
                    if (!json || json.length < 1) {
                        setItems([]);
                    }
                    else {
                            setItems(json);
                    }
                },
                (err) => {
                    setItems([]);
                }
            )
            .finally(() => setLoading(false));
    }

    function handleOpen(event: React.SyntheticEvent) {
        params.onOpen?.(event);

        if (!params.loadOnOpen) {
            return;
        }

        const parentId = params.hasParent ? params.parentId : undefined;

        if (params.hasParent && (!parentId || parentId <= 0)) {
            return;
        }

        if (params.hasParent && loadedParentId === parentId && items.length > 0) {
            return;
        }

        fetchItems(parentId).then(() => {
            if (params.hasParent && parentId) {
                setLoadedParentId(parentId);
            }
        });
    }


    return (
        params.isHiddenIfEmpty && (!items || items.length == 0) ?
            null :
            <Autocomplete
                multiple
                id="checkboxes-tags-demo"
                options={params.items && params.items.length ? items.filter(m => !params.items?.some(r => r.id == m.id)) : items}
                value={params.items || []}
                disableCloseOnSelect
                disabled={params.disabled}
                loading={isLoading}
                filterSelectedOptions
                isOptionEqualToValue={(option, value) => option.id === value.id}
                getOptionLabel={(option) => option.name}
                groupBy={(option) => params.groupedBy ? option[params.groupedBy] : null}
                onOpen={handleOpen}
                onChange={(e, v) => { params.onChange?.({ target: { name: params.name, value: v } }, v, params.name); }}
                renderTags={(value, getTagProps) => {
                    return value.map((option, index: number) => (
                        <Chip
                            label={option.name}
                            {...getTagProps({ index })}
                        />
                    ))
                }
                }
                renderInput={(props) =>
                (<TextField {...props}
                    variant={params.variant || "outlined"}
                    label={params.label}
                    placeholder="Search... &#x1F50D; "
                    required={params.required}
                    fullWidth
                    InputProps={{
                        ...props.InputProps,
                        endAdornment: (
                            <>
                                {isLoading ? <CircularProgress color="inherit" size={20} /> : null}
                                {props.InputProps.endAdornment}
                            </>
                        ),
                    }}
                />)}
            />
    );
}